module.exports = __webpack_public_path__ + "static/media/invlogo.fbcc31a5.png";